import React, { Component } from "react";
import PropTypes from "prop-types";

import { unitTransform } from '@services/helper.service';

export default class TableInput extends Component {

  static propTypes = {
    defaultUnit: PropTypes.string.isRequired,
    currentUnit: PropTypes.string.isRequired,
    className: PropTypes.string,
    name: PropTypes.string
  };

  static defaultProps = {
    className: "",
    name: ""
  };

  componentDidMount() {
    this.input = React.createRef();
  }
  
  componentDidUpdate (prevProps, prevState) {
    if (this.props.value !== prevProps.value || this.props.currentUnit !== prevProps.currentUnit) {
      this.input.current.value = unitTransform(+this.props.value || 0).from(this.props.defaultUnit).to(this.props.currentUnit);
    }
  }

  render() {
    return (
      <input
        ref={this.input}
        onClick={this.props.onClick}
        type="number"
        lang="fr"
        className={`form-control ${this.props.className}`}
        name={this.props.name}
        onBlur={e => {
          if (e.target.value === "" || e.target.value.startsWith(".") || e.target.value.startsWith(","))
          {
            let value = unitTransform(parseFloat("0" + e.target.value) || 0, false)
            .from(this.props.currentUnit)
            .to(this.props.defaultUnit);

            this.props.onInput(value, false);
          }
          this.props.onBlur();
        }}
        onFocus={this.props.onFocus}
        onChange={e => {
          const defUnitValue = unitTransform(+(Math.floor(+e.target.value + "e+2") + "e-2") || 0, false)//1111.09 not working with *100/100
            .from(this.props.currentUnit)
            .to(this.props.defaultUnit);

          let parsedNr = e.target.value.includes(".") ? 
            parseFloat(e.target.value).toFixed(e.target.value.length - e.target.value.indexOf(".") - 1) : 
            parseFloat(e.target.value);
          this.props.onInput(defUnitValue, e.target.value === "" || 
            parsedNr.toString().length !== e.target.value.toString().length || 
            e.target.value.slice(-2) === ".0");
        }}
        defaultValue={unitTransform(+this.props.value || 0)
          .from(this.props.defaultUnit)
          .to(this.props.currentUnit)
        }
      />
    );
  }

}



// WEBPACK FOOTER //
// ./src/views/Loads/components/TableInput/index.js